import { Stack, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { ACCOUNTS_BASE_PATH } from "@src/appV2/redesign/Accounts/paths";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";
import { useRef, useState } from "react";

import { UpdateEmailSteps } from "../constants";
import { EnterEmailStep } from "./components/EnterEmailStep";
import { VerifyPhoneOtpStep } from "./components/VerifyPhoneOtpStep";

export function UpdateEmailPage() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentStep, setCurrentStep] = useState<UpdateEmailSteps>(
    UpdateEmailSteps.VERIFY_PHONE_OTP
  );

  useLogEffect(APP_V2_USER_EVENTS.PROFILE_UPDATE_EMAIL_INITIATED);

  const handlePhoneOtpVerified = () => {
    setCurrentStep(UpdateEmailSteps.ENTER_EMAIL);
  };

  const handleEmailUpdated = () => {
    logEvent(APP_V2_USER_EVENTS.PROFILE_UPDATE_EMAIL_COMPLETED);
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <StickyScrollPageHeader
          title="Change Email"
          scrollContainerRef={scrollRef}
          fallbackGoBackPath={ACCOUNTS_BASE_PATH}
          headerVariant="tertiary"
        />
        <PageContent ref={scrollRef}>
          <Stack
            sx={{
              maxWidth: "600px",
              marginX: "auto",
              width: "100%",
            }}
          >
            {currentStep === UpdateEmailSteps.VERIFY_PHONE_OTP && (
              <VerifyPhoneOtpStep onVerified={handlePhoneOtpVerified} />
            )}
            {currentStep === UpdateEmailSteps.ENTER_EMAIL && (
              <EnterEmailStep onEmailUpdated={handleEmailUpdated} />
            )}
          </Stack>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
